import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import './index.external.css';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var styles = {"progress":"progress-2_TBf","spin":"spin-2_TBf","progressCircle":"progressCircle-2_TBf","strokeSpin":"strokeSpin-2_TBf","gray":"gray-2_TBf","red":"red-2_TBf","white":"white-2_TBf"};

var _excluded = ["className", "color"];
var LoadingIndicator = _ref => {
  var {
      className,
      color
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "loading-indicator",
    className: cs(className)
  }, otherProps), /*#__PURE__*/React.createElement("svg", {
    width: "44px",
    height: "44px",
    className: cs(styles.progress),
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cs(styles.progressCircle, styles[color]),
    cx: "20",
    cy: "20",
    r: "15"
  })));
};
var propTypes = {
  color: PropTypes.oneOf(['red', 'gray', 'white']),
  className: PropTypes.string
};
var defaultProps = {
  color: 'gray',
  className: null
};
LoadingIndicator.propTypes = propTypes;
LoadingIndicator.defaultProps = defaultProps;

export { LoadingIndicator, defaultProps, propTypes };
//# sourceMappingURL=index.js.map
